import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import PropertyMap from './PropertyMap';
import { apiUrl } from '../../config/api';

const readable = (value = '') => value.replace(/^ciudad-/, '').replace(/-/g, ' ');

export default function CapitalResultsMap() {
  const { barrio } = useParams();
  const navigate = useNavigate();
  const [properties, setProperties] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams({ department: 'Capital', limit: '100' });
    if (barrio) params.set('neighborhood', readable(barrio));
    fetch(apiUrl(`/properties?${params}`)).then((response) => {
      if (!response.ok) throw new Error();
      return response.json();
    }).then((data) => setProperties(Array.isArray(data?.data) ? data.data : [])).catch(() => setError('No pudimos cargar las ubicaciones.'));
  }, [barrio]);

  return <Wrapper>
    {barrio && <SelectedBarrio><span>{readable(barrio)}</span><button type="button" onClick={() => navigate('/buscar?province=mendoza&department=Capital')}>×</button></SelectedBarrio>}
    <MapFrame><PropertyMap properties={properties} /></MapFrame>
    {error && <Error>{error}</Error>}
  </Wrapper>;
}

const Wrapper = styled.div`width:100%;margin:2rem 0;`;
const SelectedBarrio = styled.div`display:inline-flex;align-items:center;gap:10px;margin-bottom:12px;padding:8px 13px;color:#fff;background:#b45f40;border-radius:999px;text-transform:capitalize;font-size:13px;button{color:inherit;background:transparent;border:0;font-size:18px;cursor:pointer;}`;
const MapFrame = styled.div`height:520px;overflow:hidden;border:1px solid rgba(42,64,70,.12);border-radius:10px;`;
const Error = styled.p`color:#9d3b2c;font-size:13px;`;
